require('./brokerMyWalletConfig.scss');

// @vendors
const React = require('react');

// @utils
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

class BrokerMyWalletConfig extends React.Component {
    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMyWallet'),
                url: ''
            }
        ];

        // @hardcoded
        const titleColumnLeftText = "Vistas personalizadas";

        return (
            <div id="brokerMyWalletConfig" className="broker-my-wallet-config-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('broker-myWalletConfigTitle')}
                    >
                        <OKButton id="btnBrokerMyWalletConfigCreateView" modifier="primary">
                            {formatText('broker-myWalletConfigCreateView')}
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section id="alertsConfigSection" className="broker-alerts-config-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <ContentBox title={titleColumnLeftText} />
                        </div>
                        <div className="col-xs-4">
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

module.exports = BrokerMyWalletConfig;
